export default __webpack_public_path__ + "static/m-feature-6-7ab1ad1f2622a4a35c36a7736d59ff06.png";